var XPortal = XPortal || {};
XPortal.Main = (function () {
    var self = {};
    self.DetialFormSelector = "div.content.detail-page, div.content.wizard-page, div.popup_detail-page";
    self.BreadCrSep = "&bc=";
    self.BreadCrPartSep = ",";
    self.BreadCrUidSep = "-";
    self.AjaxRedirectStarted = false;
    self.GridVisibleNumber = 0;
    self.idleTime = 0;
    self.counter;
    self.defaultCounterValue = 20; // 20 seconds
    self.idleInterval;
    self.counterInterval;
    self.defaultIdleTime = 600; // 10 hours
    self._allowedCookies = 'ALWD-COKIE';

    self.InitUI = function () {
        XPortal.Utils.AddProfileLink();
        moment.suppressDeprecationWarnings = true;
        //init store
        XPortal.Account.Init();
        XPortal.Store.Init();
        XPortal.Navigation.Init();
        XPortal.Grid.PreInit();
        XPortal.Sidebar.Init();
        XPortal.Dashboard.Init();
        XPortal.Tabs.Init();
        XPortal.SearchBar.Init();
        XPortal.Notificator.Init();
        XPortal.Main.customThemes();
        XPortal.Main.scrollTopButtonInit();
        self.MapBreadcrumb();
        self.LoaderOnPageLeave();
        self.QRCodeInit();
        self.HandleShowDialog();
        self.updateScrollEvent();
        self.cookiesPopupInit();
        XPortal.ActivityLoger.VisitedActivity();
        self.handleTrackLinks();
        self.handleDownloadLinks();
        self.HandleRequestSessionStorageData();
        if (XPortal.GridMap) XPortal.GridMap.Init();
        if (XPortal.EntityDetailBlock) XPortal.EntityDetailBlock.Init();
        if (XPortal.SectionBlock) XPortal.SectionBlock.Init();
        if (XPortal.Facets) XPortal.Facets.Init();
        if (XPortal.Dashboard) XPortal.Dashboard.SubscribeBlocksForUpdates();
        if (XPortal.SectionDisplayRules) XPortal.SectionDisplayRules.Init();
        if (XPortal.SectionExpandCollapse) XPortal.SectionExpandCollapse.Init();
        if (XPortal.DynamicFilters) XPortal.DynamicFilters.Init();
        if (XPortal.Comments) XPortal.Comments.Init();
        XPortal.PageHeader.Init();
        self.ShowContent();
        XPortal.Modal.init();
        XPortal.Notificator.ProcessUTCDates();
        self.IdleTimer();
        XPortal.Modal.init('#gridActionsModalBox');
        XPortal.FancyBox.init();
        XPortal.PlaceFooterBtns.Init();
        XPortal.PhoneInput.Init();
    };
    self.updateScrollEvent = function () {
        // $('.content-wrapper').on('scroll', function () {
        //     $('body').trigger('scroll');
        // });
    };
    self.IdleTimer = function () {
        var accountInfo = XPortal.Utils.readJsonStr($('.profile.account-state').attr("data-info"), null);
        if (!accountInfo) return;
        let loginName = accountInfo.name;
        let isLogin = loginName ? loginName.length : 0;
        if (!isLogin) return;
        self.counter = self.defaultCounterValue;
        self.idleInterval = setInterval(timerIncrement, 10000);
        self.idleTimeSince = moment(new Date());
        $(document).mousemove(function (e) {
            self.idleTimeSince = moment(new Date());
        });
        $(document).keypress(function (e) {
            self.idleTimeSince = moment(new Date());
        });
        $(document).on("click", ".confirm-attendance", function (evt) {
            clearInterval(self.counterInterval);
            self.counter = self.defaultCounterValue;
            self.idleInterval = setInterval(timerIncrement, 10000);
            $("#idle-modal-template").modal("hide");
            $(".idle-modal-counter").text(self.counter);
        });
    };
    self.logout = function () {
        var data = {
            RedirectUrl: "/",
            "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
        };
        var url = "/umbraco/Surface/Member/HandleLogout";
        self.logoutMember(data, url);
    };
    self.logoutMember = function (data, url) {
        var $deferred = new $.Deferred;

        $.ajax({
            url: XPortal.Utils.EnsureInProfile(url),
            type: 'POST',
            dataType: 'json',
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: data,
            success: function (response) {
                $deferred.resolve(response);
                window.location.href = response.RedirectUrl;
            },
            error: function (error) {
                $deferred.reject(error);
            }
        });

        return $deferred.promise();
    };
    function counterIncrement() {
        let headerText = $(".idle-modal-header-text").text().replace('{x}', self.counter);
        $(".idle-modal-question").text(headerText);
        self.counter--;
        if (self.counter < 1) {
            clearInterval(self.counterInterval);
            self.counter = self.defaultCounterValue;
            self.logout();
        }
    }
    function timerIncrement() {
        var idleValue = Number($("#idle-modal-template").attr("idle-time"));
        var maxIdleMins = isNaN(idleValue) || idleValue < 1 ? self.defaultIdleTime : idleValue;
        var dtNow = moment(new Date());
        var iddleMins = moment.duration(dtNow.diff(self.idleTimeSince)).asMinutes();
        if (iddleMins <= maxIdleMins) return;


        clearInterval(self.idleInterval);
        $("#idle-modal-template").modal("show");
        self.counter = self.defaultCounterValue;
        self.counterInterval = setInterval(counterIncrement, 1000);

    }
    self.BindHtmlUpdated = function () {
        $(document).one('htmlUpdated', function () {
            self.RecalculateContentElementsSizes($('body'), 200);
        });
    };
    self.RecalculateContentElementsSizes = function ($wrapper, timeOut) {
        XPortal.DropdownBtns.gridButtons.checkWithTimeout($wrapper ? $wrapper : $('body'));
        XPortal.Tabs.ResizeContent($wrapper ? $wrapper : $('.fe-area'), timeOut);
    };
    self.QRCodeInit = function () {
        var qrcodeElem = document.getElementById("qrcode");
        if (qrcodeElem) {
            var qrcode = new QRCode(qrcodeElem, {
                width: 256,
                height: 256
            });
            try {
                qrcode.makeCode(window.location.href);
            } catch (e) {
                if (console) console.warn(e);
            }
        }
    };
    self.HandleShowDialog = function () {
        $('#change-member-btn, .change-member-btn').on('click', function () {
            XPortal.Account.ShowActOnBehalfModal();
        });
    };
    self.handleTrackLinks = function () {
        var attachTrackingHandlers = function () {
            $("a[data-activity]").off('click.trackactivity').on('click.trackactivity', function (event) {
                var href = $(event.target).attr('href');
                var activityType = $(event.target).attr('data-activity');
                if (href && activityType) XPortal.ActivityLoger.TrackLinkActivity(href, activityType);
            });
        };
        var processRelatedObj = function (e) {
            if (!e.target) return;
            const trgt = $(e.target);
            const trgtData = trgt.data();
            if (!trgtData || !trgtData.kendoGrid) return;
            trgtData.kendoGrid.trigger("parent.changed.fixLayoutFunc");
            trgtData.kendoGrid.trigger("parent.changed.updateSelected");
        };
        $(document).on('htmlUpdated', function () {
            attachTrackingHandlers();
        });
        $(document).on('grid.change', function (e) {
            attachTrackingHandlers();
            processRelatedObj(e);
        });
        $(document).on('grid.dataBound', function () {
            attachTrackingHandlers();
        });
        attachTrackingHandlers();
    };
    self.handleDownloadLinks = function () {
        $(document).on('click', 'a.download', function () {
            $('html').data('showprogress', 'no');
            if (this.href.indexOf('DownloadAllAttachments') != -1) $(this).addClass("xpand-visited");
        });
    };
    self.HandleRequestSessionStorageData = function () {
        $(document).on("click", "a[data-rsst-enabled='true']", function (e) {
            e.stopPropagation();
            e.preventDefault();

            var data = {};
            var nodeId = "";
            $.each($(this)[0].attributes, function () {
                if (this.name.startsWith("data-rsst-")) {
                    var name = this.name.replace("data-rsst-", "");
                    if (name === "enabled") return;
                    if (name === "nodeid") {
                        nodeId = this.value;
                        return;
                    }
                    data[name] = this.value;
                }
            });

            var url = $(this).attr("href");
            self.getRequestSessionStoreToken(nodeId, data)
                .then(function (response) {
                    url = url.indexOf("?") !== -1
                        ? url + "&rsst=" + decodeURIComponent(response.Token)
                        : url + "?rsst=" + decodeURIComponent(response.Token);
                    XPortal.GridActions.ShowPage({
                        action: XPortal.EditForm.SetMoveLocationUrl,
                        url: url
                    });
                })
                .catch(function () {
                    XPortal.GridActions.ShowPage({
                        action: XPortal.EditForm.SetMoveLocationUrl,
                        url: url
                    });
                });
        });
    };
    self.ShowContent = function () {
        var $grids = $('.grid-parent');
        $grids.each(function () {
            var $this = $(this);
            if (XPortal.Utils.isElementVisible($this)) {
                self.GridVisibleNumber++;
            }
        });

        if (self.GridVisibleNumber == 0) {
            $('.content-wrapper').addClass('show');
        }

        setTimeout(function () {
            $('.content-wrapper, .grid-parent').addClass('show');
        }, 1000);
    };
    self.PageLeaveLoaderTimeout = 3000;
    self.LoaderOnPageLeave = function () {
        let pageLeaveLoaderKey = null;
        let pageLeaveWatchdog = 0;

        let forgetPageLeaveLoader = function () {
            clearTimeout(pageLeaveWatchdog);
            pageLeaveWatchdog = 0;
            pageLeaveLoaderKey = null;
        };
        let hidePageLeaveLoader = function () {
            if (!pageLeaveWatchdog) return;
            let key = pageLeaveLoaderKey;
            forgetPageLeaveLoader();
            if (key && $('body').children('.loader').attr('data-key') === key) {
                XPortal.Loader.hide({ selector: 'body' });
            }
        };
        let showPageLeaveLoader = function () {
            let $loader = XPortal.Loader.show({ showDelayTime: 0, color: 'transparent', bgcolor: 'transparent' });
            pageLeaveLoaderKey = $loader ? $loader.attr('data-key') : null;
            clearTimeout(pageLeaveWatchdog);
            pageLeaveWatchdog = setTimeout(hidePageLeaveLoader, self.PageLeaveLoaderTimeout);
        };
        let pageUnloadOrAjaxRequestInProgress = function () {
            let showprogresscursor = $('html').data('showprogress') || 'yes';
            if (showprogresscursor === 'yes') {
                showPageLeaveLoader();
            }
            else {
                $('html').data('showprogress', 'yes');
            }
        };

        window.addEventListener("beforeunload", function (e) {
            if (XPortal.EditForm.IsDirty()
                || !XPortal.GridInlineEditing.ValidateAllGridModels()
                || XPortal.EditForm.SaveInProgress()
                || XPortal.Store.HasInProgressEvents()) {
                // Cancel the event
                e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                // Chrome requires returnValue to be set
                e.returnValue = '';
                return;
            }

            if (!XPortal.Main.AjaxRedirectStarted) {
                pageUnloadOrAjaxRequestInProgress();
            }
        });

        window.addEventListener("pageshow", function (e) {
            if (!e.persisted) return;
            forgetPageLeaveLoader();
            XPortal.Loader.hideAll();
            $('html').data('showprogress', 'yes');
        });
    };
    self.isNonActionLink = function (link, target) {
        if (target.classList.contains('arrow')
            || link.classList.contains('ignore-unsaved')
            || link.classList.contains('fe-del-lnk')
            || link.classList.contains('fe-copy-lnk')
            || link.classList.contains('comment-attachments__link')
            || link.getAttribute('target') == 'xfe-tab'
            || link.getAttribute('target') == '_blank'
            || link.getAttribute('data-rsst-enabled') === 'true'
            || link.getAttribute('data-action') == 'Download') { //check for sidebar toggle button or FE buttons, download or _blank link
            return true;
        }

        if (link.parentElement && link.parentElement.classList && link.parentElement.classList.contains("notifications-dd")) {
            //we do not make any actions for notification link
            return true;
        }

        if (link.hasAttribute("data-toggle") || link.hasAttribute("data-action") || link.href === "" || link.href === "#" || link.href.indexOf('javascript:void(0)') > -1) {
            // buttons with commands
            return true;
        }
        if (link.hasAttribute("href") && link.attributes.href.value === "#")
            return true;
        return false;
    };
    self.InitEditControls = function (container, exceptFSets) {
        XPortal.Grid.PreInit(container);
        if (XPortal.DefaultEditor) XPortal.DefaultEditor.Init(container, exceptFSets);
        if (XPortal.BooleanEditor) XPortal.BooleanEditor.Init(container);
        if (XPortal.Hidden) XPortal.Hidden.Init(container, exceptFSets);
        if (XPortal.Multiline) XPortal.Multiline.Init(container);
        if (XPortal.DatePicker) XPortal.DatePicker.Init(container, exceptFSets);
        if (XPortal.Numeric) XPortal.Numeric.Init(container);
        if (XPortal.Dropdown) XPortal.Dropdown.Init(container, exceptFSets);
        //if (XPortal.DropdownBtns) XPortal.DropdownBtns.init(container);
        if (XPortal.UploadFiles) XPortal.UploadFiles.Init(container);
        if (XPortal.Dashboard) XPortal.Dashboard.InitSections(container);
        if (XPortal.MValuePiker) XPortal.MValuePiker.Init(container, null, exceptFSets);
        if (XPortal.CalendarPicker) XPortal.CalendarPicker.Init(container);
        if (XPortal.EntityFilterPicker) XPortal.EntityFilterPicker.Init({ container });
        if (XPortal.Measure) XPortal.Measure.Init(container);
        if (XPortal.GridMap) XPortal.GridMap.Init(container);
        if (XPortal.EntityDetailBlock) XPortal.EntityDetailBlock.Init(container);
        if (XPortal.SectionBlock) XPortal.SectionBlock.Init(container);
        if (XPortal.Facets) XPortal.Facets.Init(container);
        if (XPortal.SectionExpandCollapse) XPortal.SectionExpandCollapse.Init(container);
        if (XPortal.PasswordEditor) XPortal.PasswordEditor.Init(container);

        if (XPortal.ExTextEditor) XPortal.ExTextEditor.Init(container);
        if (XPortal.NotifyTemplateEditor) XPortal.NotifyTemplateEditor.Init(container);
        if (XPortal.SchedulerEditor) XPortal.SchedulerEditor.Init(container);
        if (XPortal.CustomLogic.NotificationsLogic) XPortal.CustomLogic.NotificationsLogic.Init(container);
        if (XPortal.TagsEditor) XPortal.TagsEditor.init(container);
        if (XPortal.Comments) XPortal.Comments.Init(container);
        if (XPortal.inputHandler) XPortal.inputHandler.Init(container);
        if (XPortal.PhoneInput) XPortal.PhoneInput.Init(container);
        if (XPortal.ToolTips) XPortal.ToolTips.InitToolTips(container);
    };
    self.InitInlineControls = function (container, modelName, options, modelFields) {

        initInlineControl(container, XPortal.DefaultEditor, (el, editor) => editor.initFor(modelName, el, true));
        initInlineControl(container, XPortal.Dropdown, (el, editor) => editor.initFor(modelName, el, true, modelFields, options.model.UniqueId));
        initInlineControl(container, XPortal.DatePicker, (el, editor) => editor.initFor(modelName, el, false, true));
        initInlineControl(container, XPortal.DatePicker, (el, editor) => editor.initFor(modelName, el, true, true), XPortal.DatePicker.ControlWithTimeSelector);
        initInlineControl(container, XPortal.Numeric, (el, editor) => editor.initFor(modelName, el, true));
        initInlineControl(container, XPortal.UploadFiles, (el, editor) => editor.initFor(el, modelName, true));
        initInlineControl(container, XPortal.Multiline, (el, editor) => editor.initFor(modelName, el, true));

        initInlineControl(container, XPortal.BooleanEditor, function (el, editor) {
            editor.initFor(modelName, el, true);
            setTimeout(function () {
                container.find(XPortal.BooleanEditor.ControlSelector).click();
            }, 0);
        });

    };
    function initInlineControl(c, edtrNS, onfound, ownselector) {
        var el = c.find(ownselector || edtrNS.ControlSelector);
        if (!el || el.length < 1) return;
        return onfound(el, edtrNS);
    }
    self.MapBreadcrumb = function () {
        const currentSessionItems = [];
        const hasReplacement = (x) => x.indexOf("[[") > -1 || x.indexOf("##") > -1;
        try {
            const currentNode = XPortal.EditForm.GetReturnNode();
            const $bcMenu = $("#breadcrumb-menu");
            if (window.location.search.indexOf(self.BreadCrSep.substring(1)) > -1) {
                $bcMenu.find("li > a[parsedpart]").each(function (i, element) {
                    const $element = $(element);
                    const nodeId = $element.attr("parsedpart");
                    let brtext = $element.text();
                    const key = "bc_" + nodeId;
                    let sessionItem = localStorage.getItem(key);
                    if (sessionItem) $element.text(sessionItem);
                    else if (!hasReplacement(brtext)) currentSessionItems.push({ key, value: brtext });
                    brtext = $element.text();
                    if (hasReplacement(brtext)) $element.closest("li").remove();
                    else $element.closest("li").removeClass("d-none");
                });
            }
            const $active = $bcMenu.find("li .hyp.active");
            if ($active.length && currentNode.NodeId) {
                const key = "bc_" + currentNode.NodeId + (currentNode.Uid ? "-" + currentNode.Uid : "");
                let res = $active.attr("data-title");

                if (currentNode.Uid && hasReplacement(res)) {
                    const $detail = $('#detail-page-' + currentNode.NodeId);
                    const modelName = XPortal.Store.getModelName($detail);
                    const model = XPortal.Store.GetModelByName(modelName);
                    const entity = model ? model.entity : null;
                    res = XPortal.Template.ReplaceFormatString(res, null, entity);
                    $active.text(res);
                    currentSessionItems.push({ key, value: res });
                }
                else currentSessionItems.push({ key, value: $active.text() });
                $active.closest("li").removeClass("d-none");
            }

            currentSessionItems.forEach(function (item) {
                localStorage.setItem(item.key, item.value);
            });
            return true;
        }
        catch (e) {
            if (console) console.error("MapBreadcrumb (...) error", e);
            return false;
        }
    };
    self.GetChildOrParentForm = function (container) {
        var frm = $(container).find("form");
        if (frm.length > 0) return $(frm[0]);
        frm = $(container).closest(".form-container").find("form");
        if (frm.length > 0) return $(frm[0]);

        return frm;
    };
    self.Redirect = function (url) {
        setTimeout(function () { window.location.href = url; }, 1000);
    };
    
    self.OnPortalFormAjaxComplete = function (response, status, xhr, dstContainer, isFromPopup) {
        if (isFromPopup)
            return XPortal.EditForm.OnPopupContentAjaxCompleted(dstContainer, response, status, xhr); 

        const rtxt = !response || !_.isString(response) || response.length < 1 ? "" : response || "";
        if (rtxt.length && rtxt.indexOf('doctype html') >= 0) return location.reload();
        const iresponse = $("<div>" + response + "</div>");
        iresponse.State = iresponse.find("input#State").val() || response.State;

        const redirectElem = iresponse.find("input#RedirectUrl");
        iresponse.RedirectUrl = !redirectElem.hasClass("ignor-ajax-reload") ? (redirectElem.val() || response.RedirectUrl) : "";

        const isLogin = $('.auth-content').length;
        XPortal.Main.AjaxRedirectStarted = !!isLogin;
        const r = $.Deferred();
        if (self.redirectToLocation(iresponse, status, xhr))
            r.reject();
        else
            XPortal.Loader.hide({ selector: isLogin ? '.auth-content' : 'body' });


        XPortal.Main.customThemes();
        r.resolve(response, status, xhr);
        r.done(function () {
            self.reloadPage(iresponse);
        });
        return r;
    };

    self.OnPortalFormAjaxCompleteWithModal = function (response, status, xhr) {
        if (response && response.Errors && response.Errors.length > 0) {
            XPortal.EditForm.ShowErrorMessage(response, $('#error-header-restricted').text());
        }
        XPortal.Main.OnPortalFormAjaxComplete(response, status, xhr);
    };

    self.redirectToLocation = function (response, status, xhr) {
        const valid = response.State == 0;
        const mresponse = response.find("[data-show-modal]");
        if (XPortal.Modal.checkIfModal(mresponse) === false && valid) {
            const url = response.RedirectUrl;
            if (url && url.length > 0) {
                self.Redirect(url);
                return true;
            }
            if ($(response).closest("#modalBox"))
                setTimeout(500, XPortal.Modal.closeModal);
        }
        else
            ajaxResponseValidation(response);
    };

    self.reloadPage = function (response) {
        if (!response.State && response.RedirectUrl) window.location.href = response.RedirectUrl;
    };

    self.getAntiForgeryToken = function (container) {
        container = container ? $(container) : null;
        if (container) return container.find('input[name="__RequestVerificationToken"]').first().val();
        return $('input[name="__RequestVerificationToken"]').first().val();
    };

    self.notifyLayoutUpdate = function (intrval) {
        intrval = intrval > 0 ? intrval : 200;
        //
        if (self.layoutUpdateTimeout) clearTimeout(self.layoutUpdateTimeout);
        self.layoutUpdateTimeout = setTimeout(function () {
            self.layoutUpdateTimeout = 0;
            $(window).trigger('resize');
        }, intrval);
    };
    self.GetSettingsFor = function (selector) {
        var el = $(selector);
        var r = { meta: {} };
        if (el[0] == null);
        else {
            $.each(_.filter(el[0].attributes, function (a) {
                return a.name.startsWith("data-");
            }), function (ix, a) {
                if (a.name.startsWith("data-metadata-")) r.meta[a.name.substring(14).toLowerCase()] = a.value;
                else r[a.name.substring(5).toLowerCase()] = a.value;
            });
        }
        r.fieldname = r.meta.fieldname;
        r.type = r.meta.type;
        r.editable = r.editable == null || r.editable === "1" ? true : false;
        r.parentInfo = r.parentinfo;
        r.valueSeparator = r["val-separator"] ? r["val-separator"] : "_#_";
        r.editable = r.editable && !el.attr("readonly");
        if (!r.value) r.value = el.val();
        return r;
    };
    self.getRequestSessionStoreToken = function (nodeId, data) {
        return XPortal.Utils.APIPost("/umbraco/Surface/Settings/GetRequestSessionStoreToken", { nodeId: nodeId, requestSessionData: data });
    };
    self.scrollTopButtonInit = function () {
        $.scrollUp({
            scrollName: 'scrollUpDesktop',
            btnClassName: 'btn-primary scroll-top-btn scroll-top-btn-desktop',
            scrollParent: '.content-wrapper',
            scrollDistance: 150,
            scrollText: '<i class="fa fa-angle-up"></i>',
        });

        $.scrollUp({
            scrollName: 'scrollUpMobile',
            btnClassName: 'btn-primary scroll-top-btn scroll-top-btn-mobile',
            scrollParent: '.page-content',
            scrollDistance: 150,
            scrollText: '<i class="fa fa-angle-up"></i>',
        });
    };
    self.cookiesPopupInit = function () {
        if (!Cookies.get(self._allowedCookies) || !JSON.parse(Cookies.get(self._allowedCookies)).allow) {
            XPortal.Loader.show({ showDelayTime: 0, color: 'transparent', bgcolor: 'transparent' });
            $('#base_app_loader').css({ 'background-color': 'rgba(239, 239, 240, 0.7)' });
            $('.cookies-popup').removeClass('closed');
        }
    }


    self.memberCookiesProcessing = function (choiceRes, elem) {
        return XPortal.Utils.APIPost("/umbraco/Surface/Settings/MemberCookiesProcessing", { ChoiceRes: choiceRes })
            .then(function (response) {
                XPortal.Loader.hide();
                elem.addClass('closed');
            });
    };

    $(document).on('click', '#cookies-allow-btn', function () {
        self.memberCookiesProcessing(1, $('.cookies-popup'));
    }).on('click', '#cookies-deny-btn', function () {
        self.memberCookiesProcessing(0, $('.cookies-popup'));
    });

    self.customThemes = function (wrpselector) {
        if (!$('body').hasClass('theme-2020'))
            return;

        wrpselector = wrpselector ? wrpselector : 'body';

        var selectorLbl = 'div:not(.with-fa-icon), .date-editor-label';
        var selectorInput = '.form-group input.form-control, .form-group textarea.form-control, .form-group select.form-control, .form-group .form-control-disabled.form-control, input[data-role="datepicker"], input[data-role="datetimepicker"], input.xpand-upload-val, .k-multiselect-wrap .k-input';
        var selectorSelect = 'select.xpand-multiselect';
        var selector = selectorInput + ', ' + selectorSelect;
        var fixedSelector = '.data-xcalendar-picker, .data-xvalue-picker, .default-editor-value-wrp > a, .scheduler-parent, .bool-item-wrapper, .fieldsContainer, .input-group-prepend, .kendoo-html-editor, .form-control-fixed';
        var $wrp = $(wrpselector);

        function noFixedControls($this) {
            return !$this.closest('.ntemplate-econtainer').length && !$this.closest('.kendoo-html-editor').length;
        }

        function checkControlChange($this) {
            var $label = $this.closest('.form-group').find(selectorLbl);
            if (($this.val() === '' || !$this.val().length) && noFixedControls($this)) {
                $label.length && $label.removeClass('focused');
            } else {
                $label.length && $label.addClass('focused');
            }
        };

        function checkFixed(selector) {
            $wrp.find(selector).each(function () {
                var $label = $(this).closest('.form-group').find(selectorLbl);
                $label.length && $label.addClass('focused');
            });
        };

        $wrp.find(selector).each(function () {
            var $this = $(this);
            if ($this.val() !== '' || $this.val().length || $this.is('[readonly]') || $this.is('[disabled]')) {
                var $label = $this.closest('.form-group').find(selectorLbl);
                $label.length && $label.addClass('focused');
            }
        });

        checkFixed(fixedSelector);
        setTimeout(function () { checkFixed('input:-internal-autofill-selected'); }, 500);

        $(document).off('.labelstyles').on('focus.labelstyles', selectorInput, function () {
            var $this = $(this);
            if ($this.is('[readonly]') || $this.is('[disabled]')) return;
            var $label = $this.closest('.form-group').find(selectorLbl);
            $label.length && $label.addClass('focused');
        }).on('blur.labelstyles', selectorInput, function () {
            var $this = $(this);
            if ($this.is('[readonly]') || $this.is('[disabled]'))
                return;
            if ((($this.val() === '' || !$this.val().length) && !$this.is('.k-input:not(.numeric):not([data-role="datepicker"]):not([data-role="datetimepicker"])'))
                || ($this.is('.k-input:not(.numeric):not([data-role="datepicker"]):not([data-role="datetimepicker"])')
                    && (!$this.parent().next().val() || !$this.parent().next().val().length))) {
                if (noFixedControls($this)) {
                    var $label = $this.closest('.form-group').find(selectorLbl);
                    $label.length && $label.removeClass('focused');
                }
            }
        }).on('editformcontrol.labelstyles', selectorInput, function () {
            checkControlChange($(this));
        }).on('change.labelstyles', selectorSelect, function () {
            checkControlChange($(this));
        }).on('focus.labelstyles', 'input, textarea, select', function () {
            var $this = $(this);
            if ($this.is('[readonly]') || $this.is('[disabled]'))
                return;
            $this.closest('.form-group').addClass('form-group-focused');
        }).on('blur.labelstyles', 'input, textarea, select', function () {
            $(this).closest('.form-group').removeClass('form-group-focused');
        });

        $('.auth-content input').removeAttr('placeholder');
    };
    $(document).ready(self.InitUI);
    $(window).resize(self.resize);
    return self;
}());